export default __webpack_public_path__ + "static/media/Walker's Gauntlets of the Everlasting Sky.2983739f.jpg";